import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import {
  getReports,
  getTotalForReports,
  initiateRefund,
} from "data/server_apis/reportService";

const initialState = {
  data: null,
  loading: false,
  success: false,
  error: false,
  total_pages:1,
  refund_status: {},
  refund_errors: {},
};


const orderAdapter = createEntityAdapter({
  selectId: (order) => order.id,
});

export const getTotalForReportsThunk = createAsyncThunk(
  "order/getInvoiceThunk",
  async (filter, { rejectWithValue }) => {
    try {
      return (await getTotalForReports(filter)).data;
    } catch (err) {
      console.log(err);
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const getReportsThunk = createAsyncThunk(
  "order/getReportsThunk",
  async (filter, { rejectWithValue }) => {
    try {
      return (await getReports(filter)).data;
    } catch (err) {
      console.log(err);
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const initiateRefundThunk = createAsyncThunk(
  "order/initiateRefundThunk",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return (await initiateRefund(id, data)).data;
    } catch (err) {
      console.log(err);
      const customError = {
        name: err.response?.status,
        message:  err.response?.data ?? null,
      };
      return rejectWithValue(customError);
    }
  }
);

const OrderSlice = createSlice({
  name: "orderSlice",
  initialState:orderAdapter.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReportsThunk.pending, (state, action) => {
        state.data = null;
        state.loading = true;
        state.success = false;
        state.error = false;
      })
      .addCase(getReportsThunk.fulfilled, (state, action) => {
        orderAdapter.setAll(state, action.payload.results);
        state.total_pages = action.payload.total_pages;
        state.loading = false;
        state.success = true;
        state.error = false;
      })
      .addCase(getReportsThunk.rejected, (state, action) => {
        state.data = null;
        state.loading = false;
        state.success = false;
        state.error = true;
      });
    builder
      .addCase(getTotalForReportsThunk.pending, (state, action) => {
        state.data = null;
        state.loading = true;
        state.success = false;
        state.error = false;
      })
      .addCase(getTotalForReportsThunk.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        state.success = false;
        state.error = false;
      })
      .addCase(getTotalForReportsThunk.rejected, (state, action) => {
        state.data = null;
        state.loading = false;
        state.success = false;
        state.error = true;
      });

    builder
      .addCase(initiateRefundThunk.pending, (state, action) => {
        const { id } = action.meta.arg;
        state.refund_status[id] = {
          loading: true,
          success: false,
          error: false,
        };
      })
      .addCase(initiateRefundThunk.fulfilled, (state, action) => {
        const { id } = action.meta.arg;
        state.refund_status[id] = {
          loading: false,
          success: true,
          error: false,
        };
        orderAdapter.updateOne(state, {
          id: action.meta.arg.id,
          changes: {refund_log:action.payload,vend_status:"failed"},
        });
        
      })
      .addCase(initiateRefundThunk.rejected, (state, action) => {
        // console.log("errrrr ",action.error)
        const { id } = action.meta.arg;
        state.refund_status[id] = {
          loading: false,
          success: false,
          error: true,
          error_message: action.payload?.message?.non_field_errors || "An error occurred",
        };
      });
  },
});

export const orderSelector = orderAdapter.getSelectors((state) => state.order);

export const {} = OrderSlice.actions;

export default OrderSlice.reducer;
